module.exports = __webpack_public_path__ + "static/media/signing_in_progress.b8b32170.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/signing_in_progress.svg
// module id = 1363
// module chunks = 0